export const STACKING_KIT_PRODUCT_TYPE_ID = '5309';
export const WALL_MOUNT_PRODUCT_TYPE_ID = '2628';
export const WALL_TYPE_SOLID = 'solid';
export const WALL_TYPE_HOLLOW = 'hollow';
export const WALL_MOUNT_TYPE_ALL = 'all';
export const WALL_MOUNT_TYPE_FIXED = 'fixed';
export const WALL_MOUNT_TYPE_TILT = 'tilt';
export const WALL_MOUNT_TYPE_TILT_AND_TURN = 'turn';
export const FIXED = ['Vast', 'Fixed', 'Fixe', 'Fest'];
export const TILT = [
    'Alleen kantelbaar',
    'Only titlable',
    'Uniquement inclinable',
    'Nur betitelbar',
];
export const TILT_AND_TURN = [
    'Draai- en kantelbaar',
    'Swivels and tilts',
    'Pivotant et inclinable',
    'Schwenkbar und neigbar',
];
export const FLEXIBILITY_PROPERTY_ID = '55003';
export const DISTANCE_WALL_PROPERTY_ID = '192096';
export const BUILD_QUALITY_PROPERTY_ID = '367366';
//# sourceMappingURL=constants.js.map